import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.access-shell {
  min-height: 100dvh;
  background: var(--review-canvas, #fafbf8);
  color: #221815;
}

.access-grid {
  min-height: 100dvh;
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(460px, 0.92fr);
}

.access-showcase {
  position: relative;
  min-height: 100dvh;
  overflow: hidden;
  padding: 38px clamp(40px, 5vw, 82px) 28px;
  background: radial-gradient(circle at 82% 10%, rgba(196, 122, 18, 0.28), transparent 27%), radial-gradient(circle at 8% 90%, rgba(75, 103, 42, 0.22), transparent 31%), linear-gradient(145deg, #fbf4e8 0%, #f1e2c9 54%, #e3e9d7 100%);
}

.access-showcase::before {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0.42;
  background-image: linear-gradient(rgba(34, 24, 21, 0.055) 1px, transparent 1px), linear-gradient(90deg, rgba(34, 24, 21, 0.055) 1px, transparent 1px);
  background-size: 52px 52px;
  mask-image: linear-gradient(to bottom right, black, transparent 78%);
}

.access-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(1px);
  pointer-events: none;
}

.access-orb--one {
  width: 380px;
  height: 380px;
  right: -220px;
  top: 22%;
  border: 1px solid rgba(169, 79, 29, 0.38);
  background: rgba(196, 122, 18, 0.04);
  box-shadow: 0 0 90px rgba(169, 79, 29, 0.14);
}

.access-orb--two {
  width: 180px;
  height: 180px;
  left: -90px;
  bottom: 12%;
  border: 1px solid rgba(75, 103, 42, 0.38);
  background: rgba(75, 103, 42, 0.05);
}

.foundation-logo-card {
  display: inline-flex;
  width: min(360px, 50vw);
  align-items: center;
  background: transparent;
}

.foundation-logo {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.text-gradient {
  color: transparent;
  background: linear-gradient(90deg, #9b471a 0%, #c47a12 52%, #a94f1d 100%);
  background-clip: text;
  -webkit-background-clip: text;
}

.workspace-preview {
  max-width: 590px;
  overflow: hidden;
  border: 1px solid rgba(25, 34, 16, 0.68);
  border-radius: 18px;
  background: radial-gradient(circle at 92% 0%, rgba(196, 122, 18, 0.17), transparent 34%), linear-gradient(145deg, #3b5023 0%, #2a391a 60%, #222e17 100%);
  box-shadow: 0 28px 64px rgba(34, 24, 21, 0.24), inset 0 1px rgba(255, 255, 255, 0.08);
}

.live-dot {
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: #c9dd7d;
  box-shadow: 0 0 0 5px rgba(201, 221, 125, 0.16);
  animation: live-pulse 2s ease-in-out infinite;
}

.access-panel {
  position: relative;
  display: flex;
  min-height: 100dvh;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 34px clamp(38px, 5vw, 74px);
  border-left: 1px solid #d5d3cc;
  background: #ffffff;
}

.access-panel::before {
  content: "";
  position: absolute;
  width: 280px;
  height: 280px;
  right: -170px;
  bottom: -170px;
  border-radius: 999px;
  border: 54px solid rgba(75, 103, 42, 0.055);
}

.mobile-brand {
  position: absolute;
  top: 22px;
  left: 24px;
  width: min(260px, 100vw - 48px);
  background: transparent;
}

.auth-wrap {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
}

.auth-tabs {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  padding: 4px;
  border: 1px solid #d2d0c9;
  border-radius: 12px;
  background: #eceee9;
}

.auth-tabs label {
  height: 38px;
  border-radius: 8px;
  color: #69645e;
  font-size: 12px;
  font-weight: 700;
  transition: 160ms ease;
}

.auth-tabs label:hover {
  color: #3e372f;
}

.auth-tabs label {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.auth-mode-input {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  opacity: 0;
  clip-path: inset(50%);
}

.auth-heading--signup,
.auth-form--signup {
  display: none;
}

#auth-mode-login:checked ~ .auth-tabs label[for=auth-mode-login],
#auth-mode-signup:checked ~ .auth-tabs label[for=auth-mode-signup] {
  color: #221815;
  background: white;
  box-shadow: 0 1px 3px rgba(34, 24, 21, 0.09), 0 1px 2px rgba(34, 24, 21, 0.05);
}

#auth-mode-login:focus-visible ~ .auth-tabs label[for=auth-mode-login],
#auth-mode-signup:focus-visible ~ .auth-tabs label[for=auth-mode-signup] {
  outline: 3px solid rgba(170, 85, 34, 0.22);
  outline-offset: 2px;
}

#auth-mode-signup:checked ~ .auth-heading .auth-heading--login,
#auth-mode-signup:checked ~ .auth-form--login {
  display: none;
}

#auth-mode-signup:checked ~ .auth-heading .auth-heading--signup,
#auth-mode-signup:checked ~ .auth-form--signup {
  display: block;
}

.field-label {
  display: block;
  margin-bottom: 8px;
  color: #403b36;
  font-size: 11px;
  font-weight: 750;
}

.field-wrap {
  position: relative;
}

.field-icon {
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 14px;
  width: 17px;
  height: 17px;
  color: #817b74;
  pointer-events: none;
  transform: translateY(-50%);
  transition: color 160ms ease;
}

.field-wrap:focus-within .field-icon {
  color: #aa5522;
}

.field-control {
  display: block;
  width: 100%;
  height: 46px;
  padding: 0 14px 0 42px;
  border: 1px solid #c8c5bd;
  border-radius: 11px;
  outline: none;
  color: #221815;
  background: white;
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(34, 24, 21, 0.028);
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.field-control::placeholder {
  color: #8f8982;
  font-weight: 400;
}

.field-control:hover {
  border-color: #969188;
}

.field-control:focus {
  border-color: #aa5522;
  box-shadow: 0 0 0 3px rgba(170, 85, 34, 0.12);
}

.field-control--password {
  padding-right: 46px;
}

.field-control--error {
  border-color: #fda4af;
  background: #fffafb;
}

.field-control--error:focus {
  border-color: #fb7185;
  box-shadow: 0 0 0 3px rgba(244, 63, 94, 0.09);
}

.password-toggle {
  position: absolute;
  z-index: 2;
  top: 50%;
  right: 8px;
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #998f84;
  transform: translateY(-50%);
  transition: 150ms ease;
}

.password-toggle:hover {
  color: #5e554c;
  background: #eceee9;
}

.field-error {
  margin-top: 6px;
  color: #e11d48;
  font-size: 10px;
  font-weight: 600;
}

.primary-button {
  display: flex;
  width: 100%;
  height: 47px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 11px;
  color: white;
  background: linear-gradient(135deg, #d08216 0%, #aa5522 100%);
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 11px 24px rgba(170, 85, 34, 0.22), inset 0 1px rgba(255, 255, 255, 0.2);
  transition: transform 160ms ease, box-shadow 160ms ease, filter 160ms ease;
}

.primary-button:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: saturate(1.08);
  box-shadow: 0 14px 28px rgba(170, 85, 34, 0.28), inset 0 1px rgba(255, 255, 255, 0.22);
}

.primary-button:active:not(:disabled) {
  transform: translateY(0);
}

.primary-button:focus-visible {
  outline: 3px solid rgba(170, 85, 34, 0.25);
  outline-offset: 2px;
}

.primary-button:disabled {
  cursor: wait;
  opacity: 0.68;
}

.button-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: white;
  border-radius: 999px;
  animation: spin 0.7s linear infinite;
}

.fade-up {
  animation: fade-up 320ms ease both;
}

@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@keyframes live-pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.45;
  }
}
@media (max-width: 1023px) {
  .access-grid {
    display: block;
  }
  .access-showcase {
    display: none;
  }
  .access-panel {
    padding: 88px 24px 34px;
  }
  .mobile-brand {
    display: block;
  }
}
@media (max-width: 479px) {
  .access-panel {
    align-items: flex-start;
    padding-right: 20px;
    padding-left: 20px;
  }
  .auth-wrap {
    max-width: none;
  }
}
@media (max-height: 790px) and (min-width: 1024px) {
  .access-showcase {
    padding-top: 28px;
    padding-bottom: 22px;
  }
  .access-showcase h1 {
    margin-top: 18px;
    font-size: 36px;
  }
  .access-showcase h1 + p {
    margin-top: 12px;
  }
  .workspace-preview {
    margin-top: 22px;
  }
  .access-panel {
    padding-top: 22px;
    padding-bottom: 22px;
  }
  .auth-tabs {
    margin-top: 18px;
  }
  form.fade-up {
    margin-top: 18px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .fade-up,
  .live-dot,
  .button-spinner {
    animation: none;
  }
}
/* Foundation palette bindings */
.text-orange-500,
.text-orange-600 {
  color: #aa5522;
}

.text-orange-200 {
  color: #efc9aa;
}

.text-emerald-300 {
  color: #cbd89b;
}

.bg-orange-400 {
  background-color: #d08216;
}

.bg-emerald-400 {
  background-color: #91a452;
}

.border-orange-300\/20 {
  border-color: rgba(208, 130, 22, 0.24);
}

.ring-orange-300\/20 {
  --tw-ring-color: rgba(208, 130, 22, 0.22);
}

.focus:ring-orange-400:focus {
  --tw-ring-color: rgba(170, 85, 34, 0.24);
}

/* High-contrast showcase for the transparent official logo */
.access-showcase header > span {
  color: #3f4930;
  border-color: rgba(52, 69, 31, 0.24);
  background: rgba(255, 255, 255, 0.76);
  box-shadow: 0 5px 14px rgba(34, 24, 21, 0.06);
}

.access-showcase .text-white {
  color: #221815;
}

.access-showcase .text-slate-300,
.access-showcase .text-slate-400 {
  color: #514c45;
}

.access-showcase .text-slate-500 {
  color: #68625b;
}

.access-showcase .text-emerald-300 {
  color: #3f5c21;
}

.access-showcase .text-orange-200 {
  color: #883b13;
}

.access-showcase .workspace-preview .text-white {
  color: #ffffff;
}

.access-showcase .workspace-preview .text-slate-500 {
  color: #c6cbb8;
}

.access-showcase .workspace-preview .text-emerald-300 {
  color: #d4e695;
}

.access-showcase .workspace-preview .text-orange-200 {
  color: #ffd18a;
}

.workspace-preview [class*=border-white] {
  border-color: rgba(255, 255, 255, 0.13);
}

.workspace-preview [class*=divide-white] > :not([hidden]) ~ :not([hidden]) {
  border-color: rgba(255, 255, 255, 0.13);
}

.workspace-preview [class*=bg-white] {
  background-color: rgba(255, 255, 255, 0.13);
}

.access-showcase footer {
  color: #4f4a42;
  border-color: rgba(34, 24, 21, 0.18);
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public view: 'login' | 'signup' = 'login';
    public showPassword: boolean = false;
    public showSignupPassword: boolean = false;
    public rememberEmail: boolean = false;
    public submitting: boolean = false;
    public loginAttempted: boolean = false;
    public signupAttempted: boolean = false;

    public data: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        agree: false
    };

    public async ngOnInit() {
        await this.service.init();
        const check = await this.service.auth.check();
        if (check) {
            location.href = this.postAuthPath(
                this.service.auth.session?.role
            );
            return;
        }

        const rememberedEmail = window.localStorage.getItem('reviewops.rememberedEmail');
        if (rememberedEmail) {
            this.data.email = rememberedEmail;
            this.rememberEmail = true;
        }
    }

    private postAuthPath(role: string | undefined): string {
        return role === 'admin' ? '/dashboard' : '/human-reviews';
    }

    public setView(view: 'login' | 'signup') {
        this.view = view;
        this.loginAttempted = false;
        this.signupAttempted = false;
        this.showPassword = false;
        this.showSignupPassword = false;

        const modeInput = document.getElementById(`auth-mode-${view}`) as HTMLInputElement | null;
        if (modeInput) modeInput.checked = true;
        void this.service.render();
    }

    public isValidEmail(email: string): boolean {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((email || '').trim());
    }

    public passwordStrength(): number {
        const password = this.signupData.password || '';
        if (!password) return 0;

        let score = 0;
        if (password.length >= 8) score++;
        if (/[A-Za-z]/.test(password) && /\d/.test(password)) score++;
        if (/[A-Z]/.test(password) && /[a-z]/.test(password)) score++;
        if (/[^A-Za-z0-9]/.test(password) && password.length >= 10) score++;
        return Math.max(1, score);
    }

    public strengthLabel(): string {
        return ['', '약함', '보통', '좋음', '안전'][this.passwordStrength()];
    }

    public strengthColor(): string {
        return ['bg-slate-200', 'bg-rose-400', 'bg-amber-400', 'bg-blue-500', 'bg-emerald-500'][this.passwordStrength()];
    }

    public strengthTextColor(): string {
        return ['text-slate-400', 'text-rose-500', 'text-amber-600', 'text-blue-600', 'text-emerald-600'][this.passwordStrength()];
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: '',
            message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status
        });
    }

    public async forgotPassword() {
        await this.alert('비밀번호 재설정은 워크스페이스 관리자에게 문의해주세요.', 'info');
    }

    public async togglePasswordVisibility(event?: Event) {
        event?.preventDefault();
        this.showPassword = !this.showPassword;
        await this.service.render();
    }

    public async toggleSignupPasswordVisibility(event?: Event) {
        event?.preventDefault();
        this.showSignupPassword = !this.showSignupPassword;
        await this.service.render();
    }

    public async login() {
        if (this.submitting) return;
        this.loginAttempted = true;

        const user = {
            email: (this.data.email || '').trim().toLowerCase(),
            password: this.data.password || ''
        };

        if (!this.isValidEmail(user.email) || !user.password) return;

        this.submitting = true;
        try {
            const response = await wiz.call('login', user);
            if (response.code === 200) {
                if (this.rememberEmail) {
                    window.localStorage.setItem('reviewops.rememberedEmail', user.email);
                } else {
                    window.localStorage.removeItem('reviewops.rememberedEmail');
                }
                location.href = this.postAuthPath(response.data?.role);
                return;
            }
            await this.alert(response.data?.message || '로그인에 실패했습니다.');
        } catch (error) {
            await this.alert('일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            this.submitting = false;
        }
    }

    public async signup() {
        if (this.submitting) return;
        this.signupAttempted = true;

        const user = {
            name: (this.signupData.name || '').trim(),
            email: (this.signupData.email || '').trim().toLowerCase(),
            password: this.signupData.password || ''
        };

        const invalid = user.name.length < 2
            || !this.isValidEmail(user.email)
            || user.password.length < 8
            || user.password !== this.signupData.passwordConfirm
            || !this.signupData.agree;

        if (invalid) return;

        this.submitting = true;
        try {
            const response = await wiz.call('signup', user);
            if (response.code === 200) {
                location.href = this.postAuthPath(response.data?.role);
                return;
            }
            await this.alert(response.data?.message || '계정을 생성하지 못했습니다.');
        } catch (error) {
            await this.alert('일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        } finally {
            this.submitting = false;
        }
    }
}

export default PageAccessComponent;